export default "/clouds.d826301d-2d3dda.svg";